import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Order } from 'src/app/common/Order';
import { OrderFilter } from 'src/app/common/OrderFilter';
import { OrderService } from 'src/app/services/order.service';
import { faInfoCircle, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { AuthorizeService } from 'src/app/auth/authorize.service';
import { Router } from '@angular/router';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { AppProfileService } from 'src/app/services/profile.service';
import { map } from 'rxjs';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { PagedList } from 'src/app/common/PagedList';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OrderSearchComponent } from '../order-search/order-search.component';
import { CommonModule } from '@angular/common';
import { GridPdfColumnsDirective } from '../grid/grid-pdf-columns.directive';
import { PdfPageComponent } from '../grid/pdf-page.component';
import { GridNoRecordsComponent } from '../grid/grid-no-records.component';

@Component({
    imports: [CommonModule, KENDO_GRID, FontAwesomeModule, OrderSearchComponent, GridPdfColumnsDirective, PdfPageComponent, GridNoRecordsComponent],
    selector: 'app-sale-order-list',
    templateUrl: './sale-order-list.component.html',
    styleUrls: ['./sale-order-list.component.css']
})
export class SaleOrderListComponent implements OnInit {
  orderService = inject(OrderService);
  private router = inject(Router);
  private profileService = inject(AppProfileService);
  authService = inject(AuthorizeService);

  private destroyRef = inject(DestroyRef);

  // Set by <app-order-search>, which emits its default criteria on init — that is the first load.
  public filter: OrderFilter;
  public faInfoCircle = faInfoCircle;
  public faFilePdf = faFilePdf;
  public isRetailer: boolean;
  public profile: ExtendedProfile = null;

  // #648: server-side paging/sorting; default order = newest first.
  public list = new PagedList<Order>({
    sortFields: { orderDateTime: 'orderDateTime' },
    defaultSort: [{ field: 'orderDateTime', dir: 'desc' }],
    fetch: (paging) =>
      this.profile && this.filter
        ? this.orderService
            .getSaleOrdersByFilter(this.filter.dateFrom, this.filter.dateTo, this.filter.customerId, [], paging)
            .pipe(
              map((r) => {
                r.items.forEach((o) => (o.orderDateTime = new Date(o.orderDateTime)));
                return r;
              })
            )
        : null,
  });

  ngOnInit() {
    this.profileService.currentProfile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((profile) => {
      this.profile = profile;
      this.isRetailer = profile?.customer.isRetailer;
      // A profile that arrives after the search criteria still gets its list.
      if (this.filter) this.list.load();
    });
  }

  search(filter: OrderFilter) {
    this.filter = filter;
    this.list.search();
  }

  public onDetails(order: Order) {
    if (this.profile.customer.isRetailer) {
      this.router.navigate(['/shop-order-seller-edit/' + order]);
    }
  }
}
